"use strict";

jQuery(document).ready(function ($) {
  $(function () {
    $('.js-question').on('click', function () {
      var $question = $(this).parent();

      if ($question.is('.is-open')) {
        $question.removeClass('is-open').find('.js-hidden-question').slideUp(300);
      } else {
        $('.js-question').not($(this)).parent().removeClass('is-open').find('.js-hidden-question').slideUp(300);
        $question.addClass('is-open').find('.js-hidden-question').slideDown(300);
      }
    });
  });
});